import React, { useCallback, useEffect } from "react";
import { PortfolioEditor } from "../PortfolioEditor";
import { Footer } from "../Footer/Footer";
import { SDialog, SDialogContent } from "./styles";
import { usePortfolioEditor, useSideEditor } from "../../../../store";

export const PortfolioEditorModal: React.FC = () => {
  const { isModalOpen, closeModal } = usePortfolioEditor();

  const { setSideEditorActive, setPortfolioBeingEdited } = useSideEditor();

  const handleCloseSideEditor = useCallback((): void => {
    setSideEditorActive(false);
    setPortfolioBeingEdited(null);
  }, [setPortfolioBeingEdited, setSideEditorActive]);

  useEffect(() => {
    handleCloseSideEditor();
  }, [isModalOpen]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <SDialog open={isModalOpen} onClose={closeModal} fullScreen>
      <SDialogContent>
        <PortfolioEditor isModal />
        {/* eslint-disable react/jsx-boolean-value */}
        <Footer onAnalysisClick={closeModal} isModal={true} />
      </SDialogContent>
    </SDialog>
  );
};
